import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-noche-dark" data-id="element-82" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-4 sm:px-5" data-id="element-83" data-mp="9tbduvlsumhr">
        <Reveal className="flex items-start gap-3 rounded-2xl border-2 border-verde bg-verde/10 p-3 text-left" data-id="element-84" data-mp="etfy8wptw1d9">
          <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border-2 border-oro bg-verde" data-id="element-85" data-mp="jsslhikm3agd">
            <ShieldCheckIcon size={24} className="text-white" data-id="element-86" data-mp="nt2qarwo3utn" />
          </span>
          <div data-id="element-87" data-mp="skcedo2kiq3f">
            <p className="font-sub text-xs font-extrabold uppercase tracking-wide text-noche-dark/80" data-id="element-88" data-mp="slvt3a8kst33">
              Tu inversión está protegida
            </p>
            <h2 id="garantia" className="font-display text-xl uppercase leading-tight text-noche sm:text-2xl" data-id="element-89" data-mp="12j0e36qoqiib">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-xs leading-snug text-noche-dark/80 sm:text-sm" data-id="element-90" data-mp="25sgh9c9kk3zt">
              Tenés 7 días para explorar los 6 tomos y los 5 bonos. Si
              considerás que el sistema no es adecuado para vos, podés
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}